<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
          </div>
          <div class="card-body">
            <div class="loader small_loader" v-if="loading"></div>
            <div class="d-flex justify-content-between align-items-center" >
              <div><button  v-if="tab==='active'" data-toggle="modal"  @click="fixModal(null)" data-target="#456" class="btn btn-outline-primary pull-left"> Add New Manual Task</button></div>
              <div class="d-flex align-items-center">
                <input v-model="searchQuery" type="text" class="form-control mr-5" style="height: 30px;" placeholder="Search..." />
                <div class="dropdown" style="width: 50px">
                  <button style="width: 20px!important; padding: 0!important;" title="Filter by Tags" class="filter-btn btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-filter fs-20 mt-2"></i>
                  </button>
                  <div style="min-width: 5rem;" class="dropdown-menu dropdown-menu-center" aria-labelledby="dropdownMenuButton2">
                    <div v-for="(option, index) in filterOptions" :key="index">
                      <div class="ml-10 mt-3 d-flex align-items-center" >
                        <input  @input="addFilter($event)" type="checkbox" v-model="selectedFilter"  :value=option>
                        <span class="text-capitalize sml-10 ml-5">{{ option }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--           <perfect-scrollbar class="scroll-area">-->
            <table class="table manual-task-table table-responsive "   :style="sortedTasks.length < 3 ? 'padding-bottom: 120px !important' : 'padding-bottom: 50px !important'">
              <thead class="light">
              <tr>
                <th width="10%" class="text-center border-grey">Service Type</th>
                <th width="10%" class="text-center border-grey">Task Type</th>
                <th width="25%" class="text-center border-grey">Domain</th>
                <th width="5%" class="text-center border-grey">Client</th>
                <th width="10%" class="text-center border-grey">Comment</th>
                <th  width="10%" class="text-center border-grey">Admin notes</th>
                <th  width="10%" class="text-center border-grey">Service Id</th>
                <th  width="10%" class="text-center border-grey">Assign</th>

<!--                <th class="text-center border-grey">Created At</th>-->
                <th  width="10%" v-if="tab==='active'" class="text-center border-grey">Checkin</th>

                <th width="15%" v-if="tab==='active'" class="text-center border-grey" >Action <i class="fa fa-bolt"></i></th>
                <th width="25%" v-if="tab==='resolved'" class="text-center border-grey"> Resolved By</th>
              </tr>
              </thead>
              <tbody >
              <tr v-if='groupTasks.length !==0' v-for="link in sortedTasks" :key="link.id" :class="checkMyTask(link.assign.uid, link.checkinByEmail)">
                <td class="text-center border-grey" width="10%">
                  <div>
                  <div class="badge badge-info">{{ link.serviceType || '' }}</div>
                  </div>
                  <div data-toggle="tooltip" data-placement="top" data-html="true" title="Priority" class="badge make-cursor-pointer" :class="link.priority === 'high' ? 'badge-danger' : link.priority === 'medium' ? 'badge-warning' : 'badge-success'">{{ link.priority }}</div>
                  <div v-if="link.linkedTask" class="badge badge-danger">Interlinked <i @click="openTaskModal(link, true)" title="View Parent Task" class="fa fa-eye ml-2 make-cursor-pointer"></i></div>
                </td>
                <td class="text-center border-grey"  width="10%">
                  {{link.taskType  }}
                </td>
                <td class="text-center text-wrap border-grey" style="width: 15rem;" width="20%">
                  <span class="text-center text-wrap" style="width: 15rem; display: inline-block;">{{link.domain}}</span>
                </td>
                <td width="5%" class="text-center text-wrap border-grey">
                  <a style="width: 6rem; display: inline-block;" :href="'https://portal.bigscoots.com/admin/?cmd=clients&action=show&id='+link.clientId" target="_blank">
                    <span style="width: 6rem;" class="text-wrap">{{link.hostBillID}}</span>
                  </a>
                </td>
<!--                <td width="5%" class="text-center">-->
<!--                  <span class="badge" :class="link.priority === 'high' ? 'badge-danger' : link.priority === 'medium' ? 'badge-warning' : 'badge-success'">{{ link.priority }}</span>-->
<!--                </td>-->
                <td width="10%" class="text-center border-grey">
                  <span  v-html="getComment(link, 'comments')"></span> <i v-if="link.taskList && link.taskList.length" title="View Task list" class=" fa fa-eye ml-5 text-primary" @click="openTaskModal(link, false)" ></i>
                </td>
                <td width="5%" class="border-grey"> <span v-html="getComment(link, 'notes')" ></span></td>
                <td class="text-center border-grey"  width="10%">

                  <template v-if="link.hbServiceId && link.hbServiceId.length===1">
                    <a v-for="(row, index) in link.hbServiceId" :key="index" target="_blank" :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${row}`">{{row}}</a>
                  </template>
                  <template v-if="link.hbServiceId && link.hbServiceId.length!==1">
                    <a v-for="(row, index) in link.hbServiceId" :key="index" target="_blank" :href="`https://portal.bigscoots.com/admin/?cmd=accounts&action=edit&id=${row}`">{{row + ', '}}</a>
                  </template>

                </td>
                <td class="text-center border-grey"  width="10%">
                  <div v-if="link.assign.uid" class="photo">
                    <img data-toggle="tooltip" data-placement="top" data-html="true" :title="link.assign.name" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(link.assign.email)}?s=40`"/>
                  </div>
                  <span v-else>None</span>
                </td>
<!--                <td class="text-center"  width="10%">-->
<!--                  <img width="20px" data-toggle="tooltip" data-placement="top" data-html="true" :title="'Created By: '+link.createdBy" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(link.createdBy, true)}?s=45`"/>-->
<!--                  <br>-->
<!--                  <span class="badge badge-info mt-4">{{link.createdAt | formatDate}}</span>-->
<!--&lt;!&ndash;                  <span class="badge badge-warning badge-sm">Created By : {{ link.createdBy }}</span>&ndash;&gt;-->
<!--                </td>-->
                <td  v-if="tab==='active'" class="text-center border-grey"  width="10%">
                  <button v-if="!link.checkinBy"  class="btn btn-primary btn-sm mr-2 check-in-button" @click="checkin(link)">
                    <div class="loader mini_loader" v-if="selectedId === link.id && action === 'checkin'"></div>
                    <span class="fs-10">checkin</span>
                  </button>
                  <template v-else>
                    <!--                    <section v-if="selectedIndex === index">-->
                    <!--                      <div class="loader" style="width: 15px; height: 15px; margin 5px" />-->
                    <!--                    </section>-->
                    <span  class="badge badge-pill badge-success ">
                      {{ link.checkinBy }}
                      <a href="javascript:void(0)" @click="checkoutTask(link)" class="fa fa-times text-white"></a>
                    </span>
                  </template>
                </td>
                <td class="pl-2 text-center border-grey"  width="10%">
                  <template v-if="tab==='active'">
<!--                    <button v-if="link.clientId && !link.linkedTask" :disabled="action === 'goToUser' && selectedId === link.id" @click="goToUser(link, 'goToUser')" class="btn btn-primary btn-sm mr-2">-->
<!--                      <i title="View Account Details" class=" fa fa-eye"></i>-->
<!--                    </button>-->
<!--                    <button @click="openTicketUrl(link)" v-if="link.ticketURL" class="btn btn-info btn-sm mr-2">-->
<!--                      <i title="View ticket url" class=" fa fa-ticket ml-2"></i>-->
<!--                    </button>-->
                    <!--                    v-if="salesToSupportTaskTypes.includes(link.taskType) && parentType === 'support'"-->
<!--                    <button :disabled="!link.checkinBy || link.resolvedAt" class="btn btn-primary btn-sm mr-2"  @click="resolveTask(link)">-->
<!--                      <div class="loader mini_loader" v-if="selectedId === link.id && action === 'resolve'"></div>-->
<!--                      <span v-else> Resolve</span>-->
<!--                    </button>-->
                    <!--                    <button v-else :disabled="!link.checkinBy || link.resolvedAt" class="btn btn-primary btn-sm mr-2" @click="resolveTask(link)">-->
                    <!--                      <div class="loader mini_loader" v-if="selectedId === link.id && action === 'resolve'"></div>-->
                    <!--                      <span v-else><i class="fa fa-refresh"></i> Resolve</span>-->
                    <!--                    </button>-->
<!--                    <button title="Login as user" :disabled="loading" class="btn btn-primary btn-sm mr-2" @click="goToUser(link, 'loginAsUser')">-->
<!--                      <i class="fa fa-user"></i>-->
<!--                    </button>-->
<!--                    <button title="Edit" class="btn btn-primary btn-sm mr-2" data-toggle="modal"  @click="fixModal(link)" data-target="#456"><i class="fa fa-pencil fa-sm"></i></button>-->
<!--                    <button v-if="user.userType === 'admin'" :disabled="action === 'delete' && selectedId === link.id" title="Delete Task" @click="removeTask(link)" class="btn btn-danger btn-sm mr-2">-->
<!--                      <i class="fa fa-times ml-2"></i>-->
<!--                    </button>-->

                    <div class="dropdown m-auto">
                      <button  style="width: 15px!important; padding: 0!important;" title="Choose Operation" class="btn settings-btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-cog" style="margin-left: 0.03rem"></i>
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="transform: translate3d(-64px, -240px, 0px) !important;">
                        <a class="dropdown-item" href="javascript:void(0)" @click="resolveTask(link)" data-target="#456">Resolve Task</a>
                        <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal"  @click="fixModal(link)" data-target="#456">Edit Task</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openTicketUrl(link)" v-if="link.ticketURL">View Ticket</a>
                        <a class="dropdown-item" href="javascript:void(0)" :disabled="loading" @click="loading?loading:goToUser(link, 'loginAsUser')">Login as User</a>
                        <a class="dropdown-item" href="javascript:void(0)" v-if="link.clientId && !link.linkedTask" :disabled="action === 'goToUser' && selectedId === link.id" @click="goToUser(link, 'goToUser')">Edit User</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openTaskModal(link, false)" >View Task Details</a>
                        <a class="dropdown-item" href="javascript:void(0)" v-if="user.userType === 'admin'" :disabled="action === 'delete' && selectedId === link.id" title="Delete Task" @click="removeTask(link)">Delete Task</a>
                      </div>
                    </div>

                  </template>
                  <template v-else-if="tab==='resolved'">
                    <span class="badge badge-success">
                      {{link.resolvedBy}}
                    </span>
                    <span class="badge badge-success" :disabled="user.email=== link.checkinBy" >{{ link.resolvedAt | formatDate }}</span>

                  </template>
                </td>
                <!--                <td  class="text-center">-->
                <!--                <span v-if="link.linkedTask" @click="openLinkedTaskModal(link)">Click here to see parent task</span>-->
                <!--                </td>-->
              </tr>
              </tbody>
              <div v-if= 'groupTasks.length ===0' class="col-sm-12  pt-2 border-grey">
                <div class="text-center text-justify pt-2"><span>No Data Available!</span></div>
              </div>
            </table>
<!--           </perfect-scrollbar>-->

            <div v-if= 'groupTasks.length !==0' class="row">
              <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ pageCount }}
                </span>
                <section class="dataTables_paginate paging_full_numbers">
                  <paginate
                      :pageCount="pageCount"
                      :clickHandler="goToPage"
                      :prevText="'Prev'"
                      :nextText="'Next'"
                      page-class="page-item"
                      prev-class="page-item"
                      prev-link-class="page-link"
                      next-class="page-item"
                      next-link-class="page-link"
                      page-link-class="page-link"
                      containerClass="pagination">
                  </paginate>
                </section>
              </div>
            </div>
<!--            <div v-else class="col-sm-12 border p-2" >-->
<!--              <div class="text-center text-justify"><span>No Data Available!</span></div>-->
<!--            </div>-->

          </div>
        </div>
      </div>

      <!-- Modal -->

      <manual-task-modal :parent-type="parentType" ref="createModal"  modalId= "456"/>
      <manual-task-detail-modal ref="tasklistModal" :parentTaskDetails="parentTaskDetails" :id="`${tab}123`"/>

      <div class="modal fade commentModal" id="commentModal" tabindex="-1" role="dialog" aria-labelledby="commentModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <form @submit.prevent="submitComment">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Comment</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Comments*</label>
                  <textarea v-model="newTask.comment" class="form-control" rows="4" required></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeCommentModal">Close</button>
                <button type="submit" class="btn btn-primary" >
                  <div class="loader small_loader" v-if="adding"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ManualTaskModal from "@/components/Admin/Sales/ManualTaskModal.vue";
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import multiSelect from "vue-multiselect";
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
import statisticsMixin from "@/mixins/statisticsMixin";
import ManualTaskDetailModal from "@/components/Admin/Sales/ManualTaskDetailModal.vue";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

export default {
  name: "ManualTaskTable",
  components: {ManualTaskDetailModal, multiSelect, Paginate,ManualTaskModal, PerfectScrollbar },
  mixins: [statisticsMixin],
  props: {
    parentType: {
      required: true,
      type: String
    },
    type: {
      type: String
    },
    tab:{
      required: true,
      type: String
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      parentTaskDetails: {mainText: ''},
      action: '',
      showLimit: false,
      limit: {
        prev: null,
        curr: null
      },
      tasks: [],
      loading: false,
      adding: false,
      newTask: {
        priority: 'low',
        ticketUrl: '',
        assign: {
          firstName: '',
          lastName: '',
          docID: '',
          email: ''
        },
        taskType : '',
        selectedUser: {
          firstName: null,
          lastName: null,
          clientId: null,
          id: null,
          email: null
        },
        clientEmail: null,
        clientId: null,
        selectedDomain: null,
        clientHostBillId : null,
        comment: '',
      },
      hbServiceID: [],
      filterOptions: ['high', 'medium', 'low', 'all'],
      salesToSupportTaskTypes: ['Termination Check'],
      selectedId : 'null',
      selectedUser: {},
      isLoading: false,
      selectedFilter: [],
      manualJobListener: null,
      showRecords: 10,
      pageNumber: 0,
      searchQuery: '',
      selectedSalesToSupportTask : {},
      adminList: []
    }
  },
  beforeDestroyed(){
    if (this.manualJobListener) {
      this.manualJobListener();
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    taskType(){
      if(this.parentType==='support'){
        return this.manualTask;
      }
      else {
        return this.salesTask
      }
    },
    groupTasks(){
      let allRemarks = this.tasks;
      if (this.selectedFilter.length) {
        allRemarks = allRemarks.filter(el => {
          if (this.selectedFilter.includes(el.priority)) {
            return true;
          }
        })
      }
      if(this.searchQuery) {
        allRemarks = allRemarks.filter(el => {
          if(el.domain && el.domain.toLowerCase().includes(this.searchQuery)) {
            return true;
          } else if(el.hostBillID && el.hostBillID.includes(this.searchQuery)) {
            return true
          }
          return false;
        })
      }
      return allRemarks;
    },
    sortedTasks(){
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      const allTasks = this.groupTasks.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks.sort((a,b)=> new Date(a.createdAt) - new Date (b.createdAt))
    },
    pageCount () {
      console.log("TEM LENGTH", this.groupTasks.length)
      let l = parseInt(this.groupTasks.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },

  },
  watch: {
    groupTasks() {
      this.pageNumber = 0;
      this.showRecords= 10
    },

  },
  mounted () {
    this.getAllTasks();
    this.getAdminList();
    $('#newAnnouncementModal').on('shown.bs.modal', function () {
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // Update state variables with new screen size
      this.screenWidth = window.innerWidth;
    },
    async getAdminList() {
      try {
        this.adminList = []
        const ref = await db.collection('users').where('userType', 'in', ['admin', 'manager']).get();
        ref.forEach(el => {
          this.adminList.push({id: el.id, email: el.data().email, name: `${el.data().firstName} ${el.data().lastName}`})
        })
      } catch (e) {
        console.log('e at 383', e.toString())
      }
    },
    openTaskModal(link , isLinkedTask, showTaskList){
      console.log(link)
      if (isLinkedTask) {
        this.parentTaskDetails = link.linkedTask
        this.parentTaskDetails.mainText = 'Parent Task Details';
      } else {
        this.parentTaskDetails = link;
        this.parentTaskDetails.mainText = 'Manual Task Details';
      }
      this.$refs.tasklistModal.showRemainingTaskList = false
      $(`#${this.tab}123`).modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    getComment(link, type) {
      let comment = null;
      if (type === 'comments') {
        comment = link.linkedTask ? link.linkedTask.comment : link.comment
        comment = link.comment || ''
        if(comment.length > 20){
          let formattedComment = '';
          const chunkLength = 20;
          for (let i = 0; i < comment.length; i += chunkLength) {
            const chunk = comment.slice(i, i + chunkLength);
            formattedComment += chunk;
            if (i + chunkLength < comment.length) {
              formattedComment += '\n';
            }
          }
          console.log(formattedComment, 'formatted comments')
          comment = formattedComment
        }

      }
      if (type === 'notes') {
        comment = link.linkedTask ? link.comment : ''
        if(comment.length > 10){
          let formattedComment = '';
          const chunkLength = 10;
          for (let i = 0; i < comment.length; i += chunkLength) {
            const chunk = comment.slice(i, i + chunkLength);
            formattedComment += chunk;
            if (i + chunkLength < comment.length) {
              formattedComment += '\n';
            }
          }
          comment = formattedComment
        }
      }
      let str = comment ? comment.split('\\n').join('<br>') : '';
      const finalComment=  str ? str.split('"').join('') : ''
      return finalComment

    },
    checkMyTask(assignedUserUid, checkInByEmail){
      if(assignedUserUid===this.user.uid || checkInByEmail=== this.user.email){
        return 'background-color-for-my-task'
      }
      return '';
    },
    openTicketUrl (link) {
      window.open(link.ticketURL, '_blank')
    },
    async submitComment() {
      try{
        this.adding = true;
        await this.resolve(this.selectedSalesToSupportTask);
        const ref = await db.collection('manualTasks').add({
          assign: {
            name:'' ,
            uid: '',
            email: ''
          },
          limit: this.limit,
          linkedTask: this.selectedSalesToSupportTask,
          hostBillID:  this.selectedSalesToSupportTask.hostBillID,
          hbServiceId:  this.selectedSalesToSupportTask.hbServiceId,
          serviceType: this.selectedSalesToSupportTask.serviceType,
          clientId: this.selectedSalesToSupportTask.clientId,
          comment: JSON.stringify(this.newTask.comment),
          domain: this.selectedSalesToSupportTask.domain,
          priority: this.selectedSalesToSupportTask.priority,
          taskType: this.selectedSalesToSupportTask.taskType,
          ticketURL:this.selectedSalesToSupportTask.ticketURL,
          resolved: false,
          type: this.parentType === 'support' ? 'sales' : 'support',
          lastMessageSentAt: new Date().toISOString(),
          createdBy: `${this.user.firstName} ${this.user.lastName}`,
          createdAt:  new Date().toISOString(),
        });
        const response = await this.$http.post('/utilities/send_manual_task_to_slack', {
          grant_type: 'token',
          assign: {
            name: '' ,
            uid: '',
            email: ''
          },
          type: this.parentType === 'support' ? 'sales' : 'support',
          taskType: this.selectedSalesToSupportTask.taskType,
          priority: this.newTask.priority,
          comment: this.newTask.comment,
          domain: this.selectedSalesToSupportTask.domain,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          taskId: ref.id
        });
        console.log('res', response)
        $("#commentModal").modal('hide');
      }
      catch(e){
        console.log("comment modal submission error", e);
      }
      finally {
        this.adding = false;
      }

    },
    async removeTask(task) {
      try {
        const result = await swal({
          title: "Delete Task",
          text: "Are you sure to delete this task?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        console.log(result)
        if (result.value) {
          this.selectedId = task.id;
          this.action = 'delete';
          await this.removeAdminActiveTask({...task , taskId : task.id} )
          await db.collection('manualTasks').doc(task.id).delete();

          swal('Success', 'You have successfully deleted task!', 'success');
        }
      } catch (e) {
        console.log('something went wrong while deleting task')
        swal('Error', 'Something went wrong while deleting task out!' + e.toString(), 'error');
      } finally {
        this.selectedId = null;
        this.action = ''
      }
    },
    emailHashGravatar(email, isAdmin) {
      if(isAdmin) {
        const obj = this.adminList.find(el => el.name === email);
        if(obj) {
          return obj.email ? md5(obj.email.trim().toLowerCase()).toString() : ''
        }
        return ''
      }
      return email ? md5(email.trim().toLowerCase()).toString() : ''
    },
    addComment(event, type) {
      if (type === 'prev') {
        this.newTask.comment = this.newTask.comment.split('\n').filter(el => {
          return !el.startsWith('Previous Limit')
        }).join('\n')
        this.newTask.comment += `Previous Limit: ${event.target.value} GB \n`;
      } else if (type === 'curr') {
        this.newTask.comment = this.newTask.comment.split('\n').filter(el => {
          return !el.startsWith('New Limit')
        }).join('\n')
        this.newTask.comment += `New Limit: ${event.target.value} GB \n`;
      }
    },
    async checkoutTask (task) {
      try {
        task.checkinBy = '';
        task.checkinByEmail = '';
        await db.collection('manualTasks').doc(task.id).update({ checkinBy: '', checkinByEmail: ''})
        const data = {
          taskId: task.id,
          ticketId: null,
          type  : 'info',
          actionType: `Manual ${task.type} Task`,
          message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been checked out by ${this.user.firstName} ${this.user.lastName}.`,
          customer: {
            email: task.hostBillID,
            domain: task.domain,
          }
        }
        await this.addRecentActivity({...data});
        await this.removeAdminActiveTask({...data})
      } catch (e) {
        console.log('something went wrong while checking out')
        swal('Error', 'Something went wrong while checking out!' + e.toString(), 'error');

      }
    },
    goToPage (pageNum) {
      this.pageNumber = pageNum - 1;
    },
    async resolve(task) {
      try {
        await db.collection('manualTasks')
            .doc(task.id)
            .update({ resolvedBy: `${this.user.firstName} ${this.user.lastName}`, resolvedAt:  new Date().toISOString() , resolved: true } );
        try {
          await this.$http.post('/utilities/update_manual_task_to_slack', {
            grant_type: 'token',
            ...task,
            resolvedBy: `${this.user.firstName} ${this.user.lastName}`,
            actionType: 'resolve'
          });
        } catch (e) {
          console.log(e.toString())
        }
        this.selectedId=null;
        try{
          await this.incrementCountBasedOnType(this.user, 'support')
          console.log('this task', task)
          await this.addRecentActivity({
            type  : 'info',
            actionType: `Manual ${task.type} Task`,
            message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been resolved by ${this.user.firstName} ${this.user.lastName}.`,
            customer: {
              email: task.hostBillID,
              domain: task.domain,
            }
          })
          task.taskId= task.id;
          await this.removeAdminActiveTask({taskId: task.id});
        }catch (e) {
          console.log('line 512', e.toString())
        }
        this.tasks = this.tasks.filter(el => el.id !== task.id)
      } catch (e) {
        swal('Error', 'Something went wrong while resolving task', 'error')
      }

    },
    resolveTask(task){
      try {
        this.selectedId=task.id;
        this.action = 'resolve';
        if(task.linkedTask){
          this.resolve(task);
          return;
        }
        let buttonHtml = '<div>' +
            '<div>Do you want to create a follow up task?? </div>' +
            '<br/>' +
            '<ul class="list-inline">' +
            '<li><button class="sw_butt1 swal2-styled" style="display: inline-block;background-color: rgb(106, 207, 152); border-left-color: rgb(106, 207, 152); border-right-color: rgb(106, 207, 152);">Resolve Task</button></li>' +
            '<li><button class="sw_butt2 swal2-styled" style="display: inline-block; background: #e6c652" >Create Followup Task</button></li>' +
            '<li><button class="sw_butt3 swal2-styled" style="display: inline-block; background-color: rgb(238, 128, 87);">Cancel</button></li>' +
            '</ul></div>'
        const self = this;
        swal({
          title: "Interlinked Task!",
          html: buttonHtml,
          type: 'question',
          showCancelButton: false,
          showConfirmButton: false,
          onOpen: function () {
            /* eslint-disable */
            $('.sw_butt2').on('click',function () {
              self.fixCommentModal(task)
              swal.close();
            });
            $('.sw_butt1').on('click',function () {
              self.resolve(task)
              swal.close();
            });
            $('.sw_butt3').on('click',function () {
              swal.close();
            });
            /* eslint-enable */
          }
        });
      } catch (e) {
        console.log(e.toString())
      } finally {
        this.selectedId = -1;
        this.action = ''
      }
    },
    async checkin(task){
      this.selectedId=task.id;
      this.action = 'checkin';
      await db.collection('manualTasks').doc(task.id).update({ checkinBy: `${this.user.firstName} ${this.user.lastName}`, checkinByEmail: this.user.email});
      this.selectedId=null;
      this.action = null
      const data= {
        taskId: task.id,
        ticketId: null,
        type  : 'info',
        actionType: `Manual ${task.type} Task`,
        message: `Manual ${task.type} task for domain ${this.domainAdjustment(task.domain)} has been checked in by ${this.user.firstName} ${this.user.lastName}.`,
        customer: {
          email: task.hostBillID,
          domain: task.domain,
        }}
      await this.addRecentActivity({...data})
      await this.addToAdminActiveTask({...data})
      try {
        await this.$http.post('/utilities/update_manual_task_to_slack', {
          grant_type: 'token',
          ...task,
          checkinBy: `${this.user.firstName} ${this.user.lastName}`,
          checkinByEmail: this.user.email
        });
      } catch (e) {
        console.log('error from updating manual task', e.toString())
      }
    },
    addFilter(event){
      const { value } = event.target;
      if (value === 'all') {
        this.selectedFilter = ['high', 'medium', 'low']
        console.log('selected filters',this.selectedFilter)
      } else {
        const index = this.selectedFilter.findIndex(el => el === 'all' )
        if (index !== -1) {
          this.selectedFilter.splice(index, 1)
        }
      }
    },
    closeModal(){
      this.newTask = {
        priority: 'low', ticketUrl: '', assign: '', taskType : '', selectedUser: {}, clientHostBillId : null, comment: ''
      }
      $('#viewTicketModal').modal('hide');
    },
    async goToUser (data, type) {
      try {
        if (!data.clientId) {
          swal('Error!', 'User not found!', 'error');
          return
        }
        this.action = 'goToUser'
        this.selectedId = data.id
        const userRef=await db.collection('users').where('customerID', '==', data.clientId).limit(1).get()
        let user=null
        if(userRef.size>0){
          userRef.forEach(el => {
            user= {id: el.id, ...el.data()}
          })
          if (type === 'loginAsUser') {
            window.open(`https://wpo.bigscoots.com/user/dashboard?id=${user.id}`,'WPO-Bigscoots');
          } else if(type === 'goToUser') {
            this.$router.push({ name: 'editUser', params: { docID: user.id } })
          }
        }else{
          swal('Error!', 'User not found!', 'error');
        }
        this.loading=false
        console.log('data',data)
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'No user found in WPO', 'error' )
      } finally {
        this.action = ''
        this.selectedId = null
      }

    },
    closeCommentModal(){
      this.newTask = {
        priority: 'low', ticketUrl: '', assign: '', taskType : '', selectedUser: {}, clientHostBillId : null, comment: ''
      }
      $('#commentModal').modal('hide');
    },
    fixModal(link=null) {
      this.$refs.createModal.fixModal(link)
    },
    fixCommentModal(task) {
      /* eslint-disable */
      this.selectedSalesToSupportTask= task;
      this.newTask.comment="";
      $("#commentModal").modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    getAllTasks () {
      this.tasks = [];
      const type= this.parentType==='sales' ? 'sales' : 'support';
      const isResolved= this.tab !== 'active';
      const taskQuery = db.collection('manualTasks').where('type', '==', type).where('resolved', '==', isResolved).orderBy('createdAt', 'desc');
      if(!this.manualJobListener){
        this.manualJobListener = taskQuery.onSnapshot(snapshot => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
              this.tasks.push({id: change.doc.id, ...change.doc.data()})
            }
            else if (change.type === 'modified') {
              this.tasks = this.tasks.filter(el => el.id !== change.doc.id)
              this.tasks.unshift({id: change.doc.id, ...change.doc.data()})
            } else if(change.type === 'removed') {
              this.tasks = this.tasks.filter(el => el.id !== change.doc.id)
            }
          })
          $(function () {
            $('[data-toggle="tooltip"]').tooltip()
          })
        });
      }
      this.loading = false;
    },
  }
}
</script>

<style scoped lang="scss">
.filter-btn, .filter-btn:active, .filter-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.filter-btn:hover {
  background-color: black !important;
  color: white !important;
}
.manual-task-table{
  min-height: 0 !important;
  margin-bottom: 0 !important;
}
.light{
  background-color: #f2f2f2 !important;
}
img {
  border-radius: 50%;
}
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
.background-color-for-my-task{
  background-color: #F5EFE4 !important;
}

.border-grey{
  border: 1px solid #ddd6d6;
}
.check-in-button{
  font-size: 0.77em !important;
  padding: 3px 6px !important;
}
</style>
<style module>
#htmlContainer {
  border: dotted black 1px;
  width: 200px;
  padding: 10px;
}
.w-255{
  height: 255px !important;
}
.dropdown-toggle:after {
  display: none;
}
.dropdown-menu-center {
  transform: translate3d(-41px, 27px, 0px) !important;
}
</style>
